import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Only from "react-only-when";
import styles from "./styles.less";
import PriceDisplay from "../../../containers/PriceDisplay";

export const TotalPrice = ({
  totalPrice,
  discountTotalPrice,
  clubUserLoggedIn,
  globalCurrency,
  globalCurrencyCode,
  titles,
  isDisplayBar,
  noMargins
}) => {
  const shouldShowTotal = totalPrice > 0;
  return (
    <React.Fragment>
      <Only when={shouldShowTotal}>
        <div
          className={cx(styles.totalPrice, {
            [styles.isDisplayBar]: isDisplayBar
          })}
        >
          <Only
            when={!clubUserLoggedIn}
            hiddenMode="withCss"
            className={styles.erased}
          >
            <div
              className={cx(styles.priceField, {
                [styles.noMargins]: noMargins
              })}
            >
              <PriceDisplay
                price={totalPrice}
                currentCurrencyCode={globalCurrencyCode}
                fallBackCurrencySymbol={globalCurrency}
              >
                {convertedPrice => convertedPrice}
              </PriceDisplay>
            </div>
          </Only>
          <Only when={clubUserLoggedIn}>
            <div
              className={cx(styles.priceField, {
                [styles.noMargins]: noMargins
              })}
            >
              <PriceDisplay
                price={discountTotalPrice}
                currentCurrencyCode={globalCurrencyCode}
                fallBackCurrencySymbol={globalCurrency}
              >
                {convertedPrice => convertedPrice}
              </PriceDisplay>
            </div>
          </Only>
        </div>
      </Only>
      <Only when={!shouldShowTotal}>
        <div>{titles.NoItemsSelected}</div>
      </Only>
    </React.Fragment>
  );
};

const CartTotalPrice = ({
  isRtl,
  bigger,
  globalCurrency,
  globalCurrencyCode,
  cartTotalPrice,
  titles,
  clubUserLoggedIn,
  simpleClubCartTotalPrice,
  isDisplayBar,
  noMargins
}) => {
  let result = (
    <div
      className={cx(styles.cartTotalPrice, {
        [styles.bigger]: bigger,
        [styles.isDisplayBar]: isDisplayBar
      })}
    >
      <div className={cx(styles.field, styles.title)}>
        {`${titles.SubTotal}:`}
      </div>
      <div className={cx(styles.field, styles.value, { [styles.rtl]: isRtl })}>
        <TotalPrice
          noMargins={noMargins}
          totalPrice={cartTotalPrice}
          discountTotalPrice={simpleClubCartTotalPrice}
          clubUserLoggedIn={clubUserLoggedIn}
          globalCurrency={globalCurrency}
          globalCurrencyCode={globalCurrencyCode}
          titles={titles}
          isDisplayBar={isDisplayBar}
        />
      </div>
    </div>
  );

  return result;
};

CartTotalPrice.defaultProps = {
  isDisplayBar: false
};

TotalPrice.defaultProps = {
  isDisplayBar: false
};

TotalPrice.propTypes = {
  noMargins: PropTypes.bool,
  totalPrice: PropTypes.number,
  discountTotalPrice: PropTypes.number,
  clubUserLoggedIn: PropTypes.bool,
  globalCurrency: PropTypes.string,
  globalCurrencyCode: PropTypes.string,
  titles: PropTypes.object,
  isDisplayBar: PropTypes.bool
};

CartTotalPrice.propTypes = {
  noMargins: PropTypes.bool,
  globalCurrency: PropTypes.string,
  globalCurrencyCode: PropTypes.string,
  titles: PropTypes.object,
  clubUserLoggedIn: PropTypes.bool,
  isRtl: PropTypes.bool,
  bigger: PropTypes.bool,
  cartTotalPrice: PropTypes.number,
  simpleClubCartTotalPrice: PropTypes.number,
  isDisplayBar: PropTypes.bool
};

export default CartTotalPrice;



// WEBPACK FOOTER //
// ./src/components/common/CartTotalPrice/CartTotalPrice.js